import type { ReactNode } from "react";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface PreviewFieldProps {
  label: string;
  children: ReactNode;
}

export const PreviewField = ({ label, children }: PreviewFieldProps) => (
  <div className="mb-4">
    <div className="mb-1">
      <span className="bg-gradient-to-r from-purple-600 to-fuchsia-600 bg-clip-text">
        <Typography.LabelSm color="text-transparent" weight="semibold">
          {label}
        </Typography.LabelSm>
      </span>
    </div>
    {children}
  </div>
);
